import { Component } from "@angular/core";
import { Platform, NavParams } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Navigator } from "src/app/services/routing/navigator";

@Component({
  selector: "app-update",
  templateUrl: "./app-update.component.html",
  styleUrls: ["./app-update.component.scss"],
})
export class AppUpdateComponent {
  private iOS: boolean = false;
  private unregisterBackButtonAction: any;
  private appVersion: any;
  private appURL: any;
  private appMessage: any;
  private btnLabel: any;

  constructor(
    protected platform: Platform,
    public config: ConfigService,
    private navParams: NavParams,
    public navigator: Navigator,
    private iab: InAppBrowser
  ) {
    this.initializeBackButtonCustomHandler();
    if (this.platform.is("ios")) {
      this.iOS = true;
    }
    this.appVersion = this.navParams.get("appversion") || "not available";
    this.appURL = this.navParams.get("appURL");
    this.appMessage =
      this.navParams.get("appMessage") || "An app update is available";
    this.btnLabel = this.navParams.get("btnLabel") || "UPDATE";
  }

  ionViewWillLeave() {
    this.unregisterBackButtonAction && this.unregisterBackButtonAction();
  }

  initializeBackButtonCustomHandler() {
    // old this.unregisterBackButtonAction = this.platform.registerBackButtonAction(function(event){
    this.platform.backButton.subscribeWithPriority(101, (event) => {
      console.log("Prevent Back Button Page Change... You Stuck!");

      this.navigator.navigateTo(
        "AppUpdateComponent",
        {},
        {
          appversion: this.appVersion,
          appURL: this.appURL,
          appMessage: this.appMessage,
          btnLabel: this.btnLabel,
        }
      );
    }); // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger then priority 100 configured in app.component.ts file */
  }

  onAppUpdate() {
    let updateURL = "";
    if (this.platform.is("android")) {
      updateURL = this.config.getConfig().APP_UPDATE_URL_ANDROID;
      console.log("updateURLAnd", updateURL);
      window.open(updateURL, "_system");
    }
    if (this.platform.is("ios")) {
      updateURL = this.config.getConfig().APP_UPDATE_URL_IOS;
      console.log("updateURLIOS", updateURL);
      this.iab.create(
        updateURL,
        "_system",
        "location=no,enableviewportscale=yes"
      );
    }
  }
}
